module.exports = __webpack_public_path__ + "static/media/social-icon-linkedin-pink.0f5c1175.svg";